<template>
  <!-- background="linear-gradient(#21346f, #151b31)" -->
  <!-- :style="{backgroundImage:require('@/assets/images/bg/banner_bg_2.jpg')}" -->
  <!-- :style="{height: contentHeight + 'px',background:'linear-gradient(rgba(0,123,255,0.8), rgba(0,123,255, 0.8)),'+'url(' + bgImg + ') no-repeat',backgroundPosition:'50%',color:'green'}" -->
  <!-- :style="{height: contentHeight + 'px',background:item.backgroundColor||''+(item.backgroundImage?','+'url(' + item.backgroundImage + ')':',url()'),backgroundPosition:'50%'}" -->
  <b-carousel id="carousel-1" :interval="interval" :indicators="dataList.length>1">
    <b-carousel-slide
      v-for="(item,index) in dataList.filter(m=>m.type=='Carousel')"
      :key="index"
      img-width="100%"
      img-height="600px"
      :style="{height: (isPhone?height/1.2:height) + 'px',background:`${(item.backgroundColor||`linear-gradient(rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)}, 0.1))`)},url(${item.backgroundUrl}) no-repeat`,backgroundSize:'cover',backgroundPosition:'center'}"
    >
      <!-- <div style="background:red;"> -->
      <!-- 大图轮播 -->
      <div class="swiper-box" :style="{height: (isPhone?height/1.2:height)-50 + 'px'}">
        <div class="container">
          <div class="row">
            <!-- ----------图片部分---------- -->
            <!-- class="col iphone-tagger" -->
            <div
              v-if="item.imageUrl"
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="50"
              data-aos-duration="800"
              class="box-img"
              :class="{'col-12 col-sm':true,'order-sm-1':!isPhone}"
            >
              <img style="max-width:100%" :src="item.imageUrl" alt />
            </div>
            <!-- ----------文字部分---------- -->
            <!-- :class="['col',item.imageUrl&&isPhone==false ? 'box-text-left' : 'box-text-center']" -->
            <div
              data-aos="fade-up"
              data-aos-offset="0"
              data-aos-delay="50"
              data-aos-duration="800"
              :class="['col-12 col-sm ',item.imageUrl&&isPhone==false ? 'box-text-left' : 'box-text-center']"
            >
              <h2 v-if="item.title" :style="{fontSize:'42px'}">{{item.title}}</h2>
              <p v-if="item.desc">{{item.desc}}</p>
              <div>
                <a v-if="item.mainButtonText" :href="item.mainButtonActionValue">
                  <el-button
                    :size="isPhone?'mini':'large'"
                    :type="item.mainButtonType||'success'"
                    style="margin: 0 10px 10px 0;"
                  >{{item.mainButtonText}}</el-button>
                </a>
                <a v-if="item.secondButtonText" :href="item.secondButtonActionValue">
                  <el-button
                    :size="isPhone?'mini':'large'"
                    :type="item.secondButtonType||'success'"
                    style="margin: 0 10px 10px 0;"
                  >{{item.secondButtonText}}</el-button>
                </a>
              </div>
              <slot :name="index"></slot>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import 'aos/dist/aos.css'
import { mapGetters } from 'vuex'
import AOS from 'aos/dist/aos.js'
export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return {}
      }
    },
    height: {
      type: Number,
      default: 350
    },
    interval: {
      type: Number,
      default: 4000
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice']),
    isPhone() {
      return document.documentElement.clientWidth < 576
    }
  },
  created() {
    AOS.init({
      offset: 100,
      duration: 300,
      easing: 'ease-in-sine'
    })
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  .iphone-tagger {
    display: none !important;
  }
  h2 {
    font-size: 22px !important;
  }
  // .box-text-center {
  //   padding-bottom: 40px !important;
  // }
  // .box-img {
  //   padding-top: 70px !important;
  // }
}
.swiper-box {
  // background: #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // h2 {
  //    font-weight: bold;
  // }
  .box-text-left {
    // background: green;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .box-text-center {
    // background: red;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
<style lang="scss">
#carousel-1 {
  .w-100 {
    height: 100% !important;
  }
}
</style>